import type { NetworkId } from "@alch/dx-entities";
import { z } from "zod";
import type { ComposerMethodConfig } from "./methods.js";
import {
  buildParamDefaultValue,
  buildParamValueSchema,
  normalizeParamName,
} from "./params.js";

export const composerFormSchemaForMethod = (
  methodConfig: ComposerMethodConfig | undefined,
  options: { strict: boolean } = { strict: true },
) => {
  return z.object({
    app: z.string().optional(),
    // Actual network validation happens in the parser
    network: z
      .string()
      .transform((val) => val as NetworkId)
      .optional(),
    method: z.string(),
    query: z.object(
      Object.fromEntries(
        methodConfig?.queryParams?.map((param) => [
          normalizeParamName(param.name || ""),
          buildParamValueSchema(param, options),
        ]) || [],
      ),
    ),
    body: methodConfig?.requestBody
      ? buildParamValueSchema(methodConfig.requestBody, options)
      : z.object({}),
  });
};

export type ComposerFormState = z.infer<
  ReturnType<typeof composerFormSchemaForMethod>
>;

export const defaultValuesForMethod = ({
  methodConfig,
  network,
}: {
  methodConfig: ComposerMethodConfig | undefined;
  network: NetworkId | undefined;
}): ComposerFormState => {
  return {
    network,
    method: methodConfig?.name || "",
    query: Object.fromEntries(
      methodConfig?.queryParams?.map((param) => [
        normalizeParamName(param.name || ""),
        buildParamDefaultValue(param),
      ]) || [],
    ),
    body: methodConfig
      ? buildParamDefaultValue(methodConfig.requestBody) || {}
      : {},
  };
};
